import React from "react";

const TableTennisMatchDetails = ({ matches, userNames, styles }) => {
  return matches.map((match, matchIndex) => {
    // Get player names using IDs for singles
    const playerAName =
      match.gameMode === "singles" && match.playerAId
        ? userNames[match.playerAId] ||
          (match.playerAId === "guest" ? "Guest Player" : "Player A")
        : "Player A";

    const playerBName =
      match.gameMode === "singles" && match.playerBId
        ? userNames[match.playerBId] ||
          (match.playerBId === "guest" ? "Guest Player" : "Player B")
        : "Player B";

    // Get team player names using IDs for doubles
    const teamAPlayer1Name =
      match.gameMode === "doubles" && match.teamA?.player1Id
        ? userNames[match.teamA.player1Id] ||
          (match.teamA.player1Id === "guest" ? "Guest Player" : "Player 1")
        : "Player 1";

    const teamAPlayer2Name =
      match.gameMode === "doubles" && match.teamA?.player2Id
        ? userNames[match.teamA.player2Id] ||
          (match.teamA.player2Id === "guest" ? "Guest Player" : "Player 2")
        : "Player 2";

    const teamBPlayer1Name =
      match.gameMode === "doubles" && match.teamB?.player1Id
        ? userNames[match.teamB.player1Id] ||
          (match.teamB.player1Id === "guest" ? "Guest Player" : "Player 1")
        : "Player 1";

    const teamBPlayer2Name =
      match.gameMode === "doubles" && match.teamB?.player2Id
        ? userNames[match.teamB.player2Id] ||
          (match.teamB.player2Id === "guest" ? "Guest Player" : "Player 2")
        : "Player 2";

    return (
      <div key={matchIndex} style={{ marginBottom: "clamp(15px, 4vw, 20px)" }}>
        <p
          style={{
            fontSize: "clamp(13px, 2.5vw, 15px)",
            marginBottom: "clamp(8px, 2vw, 10px)",
          }}
        >
          <strong>Match Type:</strong>{" "}
          {match.matchType === "best_of_5" ? "Best of 5" : "Best of 7"}
        </p>
        <p
          style={{
            fontSize: "clamp(13px, 2.5vw, 15px)",
            marginBottom: "clamp(8px, 2vw, 10px)",
          }}
        >
          <strong>Game Mode:</strong> {match.gameMode}
        </p>
        {match.gameMode === "singles" ? (
          <p
            style={{
              fontSize: "clamp(13px, 2.5vw, 15px)",
              marginBottom: "clamp(8px, 2vw, 10px)",
            }}
          >
            <strong>Players:</strong> {playerAName} vs {playerBName}
          </p>
        ) : (
          <div style={{ fontSize: "clamp(13px, 2.5vw, 15px)" }}>
            <p style={{ marginBottom: "clamp(8px, 2vw, 10px)" }}>
              <strong>Team A:</strong> {teamAPlayer1Name} & {teamAPlayer2Name}
            </p>
            <p style={{ marginBottom: "clamp(8px, 2vw, 10px)" }}>
              <strong>Team B:</strong> {teamBPlayer1Name} & {teamBPlayer2Name}
            </p>
          </div>
        )}

        <table style={styles.setsTable}>
          <thead>
            <tr>
              <th style={styles.tableTh}>Game</th>
              <th style={styles.tableTh}>
                {match.gameMode === "singles" ? playerAName : "Team A"} Points
              </th>
              <th style={styles.tableTh}>
                {match.gameMode === "singles" ? playerBName : "Team B"} Points
              </th>
            </tr>
          </thead>
          <tbody>
            {match.games.map((game, gameIndex) => (
              <tr key={gameIndex}>
                <td style={styles.tableTd}>{gameIndex + 1}</td>
                <td style={styles.tableTd}>{game.userPoints}</td>
                <td style={styles.tableTd}>{game.opponentPoints}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div
          style={{
            marginTop: "clamp(10px, 2.5vw, 15px)",
            fontSize: "clamp(13px, 2.5vw, 15px)",
          }}
        >
          <p style={{ marginBottom: "clamp(8px, 2vw, 10px)" }}>
            <strong>
              {match.gameMode === "singles" ? playerAName : "Team A"} Games Won:
            </strong>{" "}
            {match.userGames}
          </p>
          <p style={{ marginBottom: "clamp(8px, 2vw, 10px)" }}>
            <strong>
              {match.gameMode === "singles" ? playerBName : "Team B"} Games Won:
            </strong>{" "}
            {match.opponentGames}
          </p>
          <p style={{ marginBottom: "clamp(8px, 2vw, 10px)" }}>
            <strong>Winner:</strong>{" "}
            {match.winner === null
              ? "None / Draw"
              : match.winner === "user"
              ? match.gameMode === "singles"
                ? playerAName
                : "Team A"
              : match.gameMode === "singles"
              ? playerBName
              : "Team B"}
          </p>
        </div>
      </div>
    );
  });
};

export default TableTennisMatchDetails;
